import { Navigate, useLocation, useRoutes } from 'react-router-dom';
import AdminPage from '../pages/AdminPage';
import ApprovalPage from '../pages/ApprovalPage';
import ClientParent from '../pages/onboard/client/ClientParent';
import ClientPage from '../pages/ClientPage';
import ConnectionsPage from '../pages/ConnectionsPage';
import ConnectorsPage from '../pages/ConnectorsPage';
import DashboardPage from '../pages/DashboardPage';
import EngagementPage from '../pages/EngagementPage';
import ManagementPage from '../pages/ManagementPage';
import WorkflowPage from '../pages/WorkflowPage';
import WorkflowParent from '../pages/onboard/workflow/WorkflowParent';
import ViewLogs from '../components/view-logs/ViewLogs';
import DetailedLogs from '../components/logs/DetailedLogs';
import ChatGPT from '../components/chat_gpt/ChatGPT';
import EmrLogCluster from '../components/logs/emr-logs/EmrLogCluster';
import Login from '../pages/Login';
import LogDetails from '../components/logs/azure-logs/LogDetails';
import Sidebar from '../components/sidebar/Sidebar';
import PrivateRoute from './PrivateRoute';
import ChatGPTQuery from '../components/chat_gpt/ChatGPTQuery';
import RenderHtml from '../components/RenderHtml';
import UploadFiles from '../components/chat_gpt/UploadFiles';
import AboutModal from '../components/AboutModal';
import LogsAnalyticsData from '../components/logs/azure-logs/LogsAnalyticsData';
import SnowflakeLogs from '../components/logs/snowflake-logs/SnowflakeLogs';
import DomainPage from '../pages/DomainPage';
import DomainDetails from '../pages/domain-details/DomainDetails';
import ClientDetails from '../pages/client-details/ClientDetails';
import EngagementDetails from '../pages/engagement-details/EngagementDetails';
import ChatGPTFs from '../components/chat_gpt/ChatGPTFs';
import LLMPage from '../pages/LLMPage';
import ClusterPage from '../pages/ClusterPage';
import ClusterConfigResultParentPage from '../pages/ClusterConfigResultParentPage';
import Asset360Page from '../pages/data-model/Asset360Page';
import Customer360Page from '../pages/data-model/Customer360Page';
import Company360Page from '../pages/data-model/Company360Page';
import PageNotFound from '../pages/PageNotFound';

export default function Router() {
  const location = useLocation();

  return useRoutes([
    { path: '/', element: <Login /> },
    {
      path: '/dashboard',
      element: <PrivateRoute />,
      children: [
        {
          path: '',
          element: <Sidebar />,
          children: [{ path: '', element: <DashboardPage /> }],
        },
      ],
    },
    {
      path: '/domain',
      element: <PrivateRoute />,
      children: [
        {
          path: '',
          element: <Sidebar />,
          children: [
            { path: '', element: <DomainPage /> },
            { path: 'view_details', element: <DomainDetails headerTableData={location.state} /> },
            // { path: 'onboarding', element: <ClientParent /> },
          ],
        },
      ],
    },
    {
      path: '/data-model',
      element: <PrivateRoute />,
      children: [
        {
          path: '',
          element: <Sidebar />,
          children: [
            { path: '', element: <Navigate to="asset360" replace /> },
            { path: 'asset360', element: <Asset360Page /> },
            { path: 'customer360', element: <Customer360Page /> },
            { path: 'company360', element: <Company360Page /> },
          ],
        },
      ],
    },

    {
      path: '/client',
      element: <PrivateRoute />,
      children: [
        {
          path: '',
          element: <Sidebar />,
          children: [
            { path: '', element: <ClientPage /> },
            { path: 'view_details', element: <ClientDetails headerTableData={location.state} /> },
            { path: 'onboarding', element: <ClientParent /> },
          ],
        },
      ],
    },

    {
      path: '/workflow-llm',
      element: <PrivateRoute />,
      children: [
        {
          path: '',
          element: <Sidebar />,
          children: [
            { path: '', element: <WorkflowPage processType="llm" /> },
            {
              path: 'onboarding',
              element: <WorkflowParent headerTableData={location.state} processType="llm" />,
            },
            {
              path: 'logs/data-processor',
              element: <ViewLogs headerTableData={location.state} processType="llm" />,
            },
            {
              path: 'logs/data-processor/details',
              element: <LogDetails headerTableData={location.state} processType="llm" />,
            },
            {
              path: 'logs/rule-engine',
              element: <ViewLogs headerTableData={location.state} processType="llm" />,
            },
            {
              path: 'logs/rule-engine/details',
              element: <LogDetails headerTableData={location.state} processType="llm" />,
            },
            {
              path: 'logs/detailed-logs',
              element: <DetailedLogs headerTableData={location.state} processType="llm" />,
            },
            {
              path: 'logs/log-analytics/detailed-logs',
              element: <LogsAnalyticsData headerTableData={location.state} processType="llm" />,
            },
            {
              path: 'logs/emr-logs/:batch/:job/:cluster',
              element: <EmrLogCluster processType="llm" />,
            },
          ],
        },
      ],
    },
    {
      path: '/workflow-cluster',
      element: <PrivateRoute />,
      children: [
        {
          path: '',
          element: <Sidebar />,
          children: [
            { path: '', element: <ClusterPage /> },
            { path: 'records', element: <ClusterConfigResultParentPage /> },
            // { path: 'logs/data-processor', element: <ViewLogs headerTableData={location.state} /> },
            // { path: 'logs/data-processor/details', element: <LogDetails headerTableData={location.state} /> },
            // { path: 'logs/rule-engine', element: <ViewLogs headerTableData={location.state} /> },
            // { path: 'logs/rule-engine/details', element: <LogDetails headerTableData={location.state} /> },
            // { path: 'logs/detailed-logs', element: <DetailedLogs headerTableData={location.state} /> },
            // {
            //   path: 'logs/log-analytics/detailed-logs',
            //   element: <LogsAnalyticsData headerTableData={location.state} />,
            // },
            // { path: 'logs/emr-logs/:batch/:job/:cluster', element: <EmrLogCluster /> },
            // { path: 'profiling', element: <RenderHtml /> },
          ],
        },
      ],
    },
    {
      path: '/workflow-xperience360',
      element: <PrivateRoute />,
      children: [
        {
          path: '',
          element: <Sidebar />,
          children: [
            { path: '', element: <ClusterPage processType="xperience360" /> },
            {
              path: 'onboarding',
              element: <WorkflowParent headerTableData={location.state} processType="xperience360" />,
            },
            {
              path: 'logs/data-processor',
              element: <ViewLogs headerTableData={location.state} processType="xperience360" />,
            },
            {
              path: 'logs/data-processor/details',
              element: <LogDetails headerTableData={location.state} processType="xperience360" />,
            },
            {
              path: 'logs/rule-engine',
              element: <ViewLogs headerTableData={location.state} processType="xperience360" />,
            },
            {
              path: 'logs/rule-engine/details',
              element: <LogDetails headerTableData={location.state} processType="xperience360" />,
            },
            {
              path: 'logs/log-analytics/detailed-logs',
              element: <LogsAnalyticsData headerTableData={location.state} processType="xperience360" />,
            },
            {
              path: 'logs/detailed-logs',
              element: <DetailedLogs headerTableData={location.state} processType="xperience360" />,
            },
            { path: 'logs/emr-logs/:batch/:job/:cluster', element: <EmrLogCluster processType="xperience360" /> },
          ],
        },
      ],
    },
    {
      path: '/workflow-generic-generic',
      element: <PrivateRoute />,
      children: [
        {
          path: '',
          element: <Sidebar />,
          children: [
            { path: '', element: <ClusterPage processType="Generic" processWorkflowType="Generic" /> },
            {
              path: 'onboarding',
              element: (
                <WorkflowParent headerTableData={location.state} processType="Generic" processWorkflowType="Generic" />
              ),
            },
            {
              path: 'logs/data-processor',
              element: (
                <ViewLogs headerTableData={location.state} processType="Generic" processWorkflowType="Generic" />
              ),
            },
            {
              path: 'logs/data-processor/details',
              element: (
                <LogDetails headerTableData={location.state} processType="Generic" processWorkflowType="Generic" />
              ),
            },
            {
              path: 'logs/rule-engine',
              element: (
                <ViewLogs headerTableData={location.state} processType="Generic" processWorkflowType="Generic" />
              ),
            },
            {
              path: 'logs/rule-engine/details',
              element: (
                <LogDetails headerTableData={location.state} processType="Generic" processWorkflowType="Generic" />
              ),
            },
            {
              path: 'logs/log-analytics/detailed-logs',
              element: (
                <LogsAnalyticsData
                  headerTableData={location.state}
                  processType="Generic"
                  processWorkflowType="Generic"
                />
              ),
            },
            {
              path: 'logs/detailed-logs',
              element: (
                <DetailedLogs headerTableData={location.state} processType="Generic" processWorkflowType="Generic" />
              ),
            },
            {
              path: 'logs/emr-logs/:batch/:job/:cluster',
              element: <EmrLogCluster processType="Generic" processWorkflowType="Generic" />,
            },
          ],
        },
      ],
    },
    {
      path: '/workflow-customer360-golden-records',
      element: <PrivateRoute />,
      children: [
        {
          path: '',
          element: <Sidebar />,
          children: [
            { path: '', element: <ClusterPage processType="Customer 360" processWorkflowType="Golden Records" /> },
            {
              path: 'onboarding',
              element: (
                <WorkflowParent
                  headerTableData={location.state}
                  processType="Customer 360"
                  processWorkflowType="Golden Records"
                />
              ),
            },
            {
              path: 'logs/data-processor',
              element: (
                <ViewLogs
                  headerTableData={location.state}
                  processType="Customer 360"
                  processWorkflowType="Golden Records"
                />
              ),
            },
            {
              path: 'logs/data-processor/details',
              element: (
                <LogDetails
                  headerTableData={location.state}
                  processType="Customer 360"
                  processWorkflowType="Golden Records"
                />
              ),
            },
            {
              path: 'logs/rule-engine',
              element: (
                <ViewLogs
                  headerTableData={location.state}
                  processType="Customer 360"
                  processWorkflowType="Golden Records"
                />
              ),
            },
            {
              path: 'logs/rule-engine/details',
              element: (
                <LogDetails
                  headerTableData={location.state}
                  processType="Customer 360"
                  processWorkflowType="Golden Records"
                />
              ),
            },
            {
              path: 'logs/log-analytics/detailed-logs',
              element: (
                <LogsAnalyticsData
                  headerTableData={location.state}
                  processType="Customer 360"
                  processWorkflowType="Golden Records"
                />
              ),
            },
            {
              path: 'logs/detailed-logs',
              element: (
                <DetailedLogs
                  headerTableData={location.state}
                  processType="Customer 360"
                  processWorkflowType="Golden Records"
                />
              ),
            },
            {
              path: 'logs/emr-logs/:batch/:job/:cluster',
              element: <EmrLogCluster processType="Customer 360" processWorkflowType="Golden Records" />,
            },
          ],
        },
      ],
    },
    {
      path: '/workflow-customer360-segmentation',
      element: <PrivateRoute />,
      children: [
        {
          path: '',
          element: <Sidebar />,
          children: [
            { path: '', element: <ClusterPage processType="Customer 360" processWorkflowType="Segmentation" /> },
            {
              path: 'onboarding',
              element: (
                <WorkflowParent
                  headerTableData={location.state}
                  processType="Customer 360"
                  processWorkflowType="Segmentation"
                />
              ),
            },
            {
              path: 'logs/data-processor',
              element: (
                <ViewLogs
                  headerTableData={location.state}
                  processType="Customer 360"
                  processWorkflowType="Segmentation"
                />
              ),
            },
            {
              path: 'logs/data-processor/details',
              element: (
                <LogDetails
                  headerTableData={location.state}
                  processType="Customer 360"
                  processWorkflowType="Segmentation"
                />
              ),
            },
            {
              path: 'logs/rule-engine',
              element: (
                <ViewLogs
                  headerTableData={location.state}
                  processType="Customer 360"
                  processWorkflowType="Segmentation"
                />
              ),
            },
            {
              path: 'logs/rule-engine/details',
              element: (
                <LogDetails
                  headerTableData={location.state}
                  processType="Customer 360"
                  processWorkflowType="Segmentation"
                />
              ),
            },
            {
              path: 'logs/log-analytics/detailed-logs',
              element: (
                <LogsAnalyticsData
                  headerTableData={location.state}
                  processType="Customer 360"
                  processWorkflowType="Segmentation"
                />
              ),
            },
            {
              path: 'logs/detailed-logs',
              element: (
                <DetailedLogs
                  headerTableData={location.state}
                  processType="Customer 360"
                  processWorkflowType="Segmentation"
                />
              ),
            },
            {
              path: 'logs/emr-logs/:batch/:job/:cluster',
              element: <EmrLogCluster processType="Customer 360" processWorkflowType="Segmentation" />,
            },
          ],
        },
      ],
    },
    {
      path: '/workflow-customer360-analysis',
      element: <PrivateRoute />,
      children: [
        {
          path: '',
          element: <Sidebar />,
          children: [
            { path: '', element: <ClusterPage processType="Customer 360" processWorkflowType="Analysis" /> },
            {
              path: 'onboarding',
              element: (
                <WorkflowParent
                  headerTableData={location.state}
                  processType="Customer 360"
                  processWorkflowType="Analysis"
                />
              ),
            },
            {
              path: 'logs/data-processor',
              element: (
                <ViewLogs headerTableData={location.state} processType="Customer 360" processWorkflowType="Analysis" />
              ),
            },
            {
              path: 'logs/data-processor/details',
              element: (
                <LogDetails
                  headerTableData={location.state}
                  processType="Customer 360"
                  processWorkflowType="Analysis"
                />
              ),
            },
            {
              path: 'logs/rule-engine',
              element: (
                <ViewLogs headerTableData={location.state} processType="Customer 360" processWorkflowType="Analysis" />
              ),
            },
            {
              path: 'logs/rule-engine/details',
              element: (
                <LogDetails
                  headerTableData={location.state}
                  processType="Customer 360"
                  processWorkflowType="Analysis"
                />
              ),
            },
            {
              path: 'logs/log-analytics/detailed-logs',
              element: (
                <LogsAnalyticsData
                  headerTableData={location.state}
                  processType="Customer 360"
                  processWorkflowType="Analysis"
                />
              ),
            },
            {
              path: 'logs/detailed-logs',
              element: (
                <DetailedLogs
                  headerTableData={location.state}
                  processType="Customer 360"
                  processWorkflowType="Analysis"
                />
              ),
            },
            {
              path: 'logs/emr-logs/:batch/:job/:cluster',
              element: <EmrLogCluster processType="Customer 360" processWorkflowType="Analysis" />,
            },
          ],
        },
      ],
    },
    {
      path: '/workflow-asset360-golden-records',
      element: <PrivateRoute />,
      children: [
        {
          path: '',
          element: <Sidebar />,
          children: [
            {
              path: '',
              element: <ClusterPage processType="Asset 360" processWorkflowType="Golden Records" />,
            },
            {
              path: 'onboarding',
              element: (
                <WorkflowParent
                  headerTableData={location.state}
                  processType="Asset 360"
                  processWorkflowType="Golden Records"
                />
              ),
            },
            {
              path: 'logs/data-processor',
              element: (
                <ViewLogs
                  headerTableData={location.state}
                  processType="Asset 360"
                  processWorkflowType="Golden Records"
                />
              ),
            },
            {
              path: 'logs/data-processor/details',
              element: (
                <LogDetails
                  headerTableData={location.state}
                  processType="Asset 360"
                  processWorkflowType="Golden Records"
                />
              ),
            },
            {
              path: 'logs/rule-engine',
              element: (
                <ViewLogs
                  headerTableData={location.state}
                  processType="Asset 360"
                  processWorkflowType="Golden Records"
                />
              ),
            },
            {
              path: 'logs/rule-engine/details',
              element: (
                <LogDetails
                  headerTableData={location.state}
                  processType="Asset 360"
                  processWorkflowType="Golden Records"
                />
              ),
            },
            {
              path: 'logs/log-analytics/detailed-logs',
              element: (
                <LogsAnalyticsData
                  headerTableData={location.state}
                  processType="Asset 360"
                  processWorkflowType="Golden Records"
                />
              ),
            },
            {
              path: 'logs/detailed-logs',
              element: (
                <DetailedLogs
                  headerTableData={location.state}
                  processType="Asset 360"
                  processWorkflowType="Golden Records"
                />
              ),
            },
            {
              path: 'logs/emr-logs/:batch/:job/:cluster',
              element: <EmrLogCluster processType="Asset 360" processWorkflowType="Golden Records" />,
            },
          ],
        },
      ],
    },
    {
      path: '/workflow-asset360-analysis',
      element: <PrivateRoute />,
      children: [
        {
          path: '',
          element: <Sidebar />,
          children: [
            { path: '', element: <ClusterPage processType="Asset 360" processWorkflowType="Analysis" /> },
            {
              path: 'onboarding',
              element: (
                <WorkflowParent
                  headerTableData={location.state}
                  processType="Asset 360"
                  processWorkflowType="Analysis"
                />
              ),
            },
            {
              path: 'logs/data-processor',
              element: (
                <ViewLogs headerTableData={location.state} processType="Asset 360" processWorkflowType="Analysis" />
              ),
            },
            {
              path: 'logs/data-processor/details',
              element: (
                <LogDetails headerTableData={location.state} processType="Asset 360" processWorkflowType="Analysis" />
              ),
            },
            {
              path: 'logs/rule-engine',
              element: (
                <ViewLogs headerTableData={location.state} processType="Asset 360" processWorkflowType="Analysis" />
              ),
            },
            {
              path: 'logs/rule-engine/details',
              element: (
                <LogDetails headerTableData={location.state} processType="Asset 360" processWorkflowType="Analysis" />
              ),
            },
            {
              path: 'logs/log-analytics/detailed-logs',
              element: (
                <LogsAnalyticsData
                  headerTableData={location.state}
                  processType="Asset 360"
                  processWorkflowType="Analysis"
                />
              ),
            },
            {
              path: 'logs/detailed-logs',
              element: (
                <DetailedLogs headerTableData={location.state} processType="Asset 360" processWorkflowType="Analysis" />
              ),
            },
            {
              path: 'logs/emr-logs/:batch/:job/:cluster',
              element: <EmrLogCluster processType="Asset 360" processWorkflowType="Analysis" />,
            },
          ],
        },
      ],
    },
    {
      path: '/workflow-asset360-segmentation',
      element: <PrivateRoute />,
      children: [
        {
          path: '',
          element: <Sidebar />,
          children: [
            { path: '', element: <ClusterPage processType="Asset 360" processWorkflowType="Segmentation" /> },
            {
              path: 'onboarding',
              element: (
                <WorkflowParent
                  headerTableData={location.state}
                  processType="Asset 360"
                  processWorkflowType="Segmentation"
                />
              ),
            },
            {
              path: 'logs/data-processor',
              element: (
                <ViewLogs headerTableData={location.state} processType="Asset 360" processWorkflowType="Segmentation" />
              ),
            },
            {
              path: 'logs/data-processor/details',
              element: (
                <LogDetails
                  headerTableData={location.state}
                  processType="Asset 360"
                  processWorkflowType="Segmentation"
                />
              ),
            },
            {
              path: 'logs/rule-engine',
              element: (
                <ViewLogs headerTableData={location.state} processType="Asset 360" processWorkflowType="Segmentation" />
              ),
            },
            {
              path: 'logs/rule-engine/details',
              element: (
                <LogDetails
                  headerTableData={location.state}
                  processType="Asset 360"
                  processWorkflowType="Segmentation"
                />
              ),
            },
            {
              path: 'logs/log-analytics/detailed-logs',
              element: (
                <LogsAnalyticsData
                  headerTableData={location.state}
                  processType="Asset 360"
                  processWorkflowType="Segmentation"
                />
              ),
            },
            {
              path: 'logs/detailed-logs',
              element: (
                <DetailedLogs
                  headerTableData={location.state}
                  processType="Asset 360"
                  processWorkflowType="Segmentation"
                />
              ),
            },
            {
              path: 'logs/emr-logs/:batch/:job/:cluster',
              element: <EmrLogCluster processType="Asset 360" processWorkflowType="Segmentation" />,
            },
          ],
        },
      ],
    },
    {
      path: '/workflow-company360-analysis',
      element: <PrivateRoute />,
      children: [
        {
          path: '',
          element: <Sidebar />,
          children: [
            { path: '', element: <ClusterPage processType="Company 360" processWorkflowType="Analysis" /> },
            {
              path: 'onboarding',
              element: (
                <WorkflowParent
                  headerTableData={location.state}
                  processType="Company 360"
                  processWorkflowType="Analysis"
                />
              ),
            },
            {
              path: 'logs/data-processor',
              element: (
                <ViewLogs headerTableData={location.state} processType="Company 360" processWorkflowType="Analysis" />
              ),
            },
            {
              path: 'logs/data-processor/details',
              element: (
                <LogDetails headerTableData={location.state} processType="Company 360" processWorkflowType="Analysis" />
              ),
            },
            {
              path: 'logs/rule-engine',
              element: (
                <ViewLogs headerTableData={location.state} processType="Company 360" processWorkflowType="Analysis" />
              ),
            },
            {
              path: 'logs/rule-engine/details',
              element: (
                <LogDetails headerTableData={location.state} processType="Company 360" processWorkflowType="Analysis" />
              ),
            },
            {
              path: 'logs/log-analytics/detailed-logs',
              element: (
                <LogsAnalyticsData
                  headerTableData={location.state}
                  processType="Company 360"
                  processWorkflowType="Analysis"
                />
              ),
            },
            {
              path: 'logs/detailed-logs',
              element: (
                <DetailedLogs
                  headerTableData={location.state}
                  processType="Company 360"
                  processWorkflowType="Analysis"
                />
              ),
            },
            {
              path: 'logs/emr-logs/:batch/:job/:cluster',
              element: <EmrLogCluster processType="Company 360" processWorkflowType="Analysis" />,
            },
          ],
        },
      ],
    },
    {
      path: '/workflow-company360-segmentation',
      element: <PrivateRoute />,
      children: [
        {
          path: '',
          element: <Sidebar />,
          children: [
            { path: '', element: <ClusterPage processType="Company 360" processWorkflowType="Segmentation" /> },
            {
              path: 'onboarding',
              element: (
                <WorkflowParent
                  headerTableData={location.state}
                  processType="Company 360"
                  processWorkflowType="Segmentation"
                />
              ),
            },
            {
              path: 'logs/data-processor',
              element: (
                <ViewLogs
                  headerTableData={location.state}
                  processType="Company 360"
                  processWorkflowType="Segmentation"
                />
              ),
            },
            {
              path: 'logs/data-processor/details',
              element: (
                <LogDetails
                  headerTableData={location.state}
                  processType="Company 360"
                  processWorkflowType="Segmentation"
                />
              ),
            },
            {
              path: 'logs/rule-engine',
              element: (
                <ViewLogs
                  headerTableData={location.state}
                  processType="Company 360"
                  processWorkflowType="Segmentation"
                />
              ),
            },
            {
              path: 'logs/rule-engine/details',
              element: (
                <LogDetails
                  headerTableData={location.state}
                  processType="Company 360"
                  processWorkflowType="Segmentation"
                />
              ),
            },
            {
              path: 'logs/log-analytics/detailed-logs',
              element: (
                <LogsAnalyticsData
                  headerTableData={location.state}
                  processType="Company 360"
                  processWorkflowType="Segmentation"
                />
              ),
            },
            {
              path: 'logs/detailed-logs',
              element: (
                <DetailedLogs
                  headerTableData={location.state}
                  processType="Company 360"
                  processWorkflowType="Segmentation"
                />
              ),
            },
            {
              path: 'logs/emr-logs/:batch/:job/:cluster',
              element: <EmrLogCluster processType="Company 360" processWorkflowType="Segmentation" />,
            },
          ],
        },
      ],
    },
    {
      path: '/workflow-company360-golden-records',
      element: <PrivateRoute />,
      children: [
        {
          path: '',
          element: <Sidebar />,
          children: [
            {
              path: '',
              element: <ClusterPage processType="Company 360" processWorkflowType="Golden Records" />,
            },
            {
              path: 'onboarding',
              element: (
                <WorkflowParent
                  headerTableData={location.state}
                  processType="Company 360"
                  processWorkflowType="Golden Records"
                />
              ),
            },
            {
              path: 'logs/data-processor',
              element: (
                <ViewLogs
                  headerTableData={location.state}
                  processType="Company 360"
                  processWorkflowType="Golden Records"
                />
              ),
            },
            {
              path: 'logs/data-processor/details',
              element: (
                <LogDetails
                  headerTableData={location.state}
                  processType="Company 360"
                  processWorkflowType="Golden Records"
                />
              ),
            },
            {
              path: 'logs/rule-engine',
              element: (
                <ViewLogs
                  headerTableData={location.state}
                  processType="Company 360"
                  processWorkflowType="Golden Records"
                />
              ),
            },
            {
              path: 'logs/rule-engine/details',
              element: (
                <LogDetails
                  headerTableData={location.state}
                  processType="Company 360"
                  processWorkflowType="Golden Records"
                />
              ),
            },
            {
              path: 'logs/log-analytics/detailed-logs',
              element: (
                <LogsAnalyticsData
                  headerTableData={location.state}
                  processType="Company 360"
                  processWorkflowType="Golden Records"
                />
              ),
            },
            {
              path: 'logs/detailed-logs',
              element: (
                <DetailedLogs
                  headerTableData={location.state}
                  processType="Company 360"
                  processWorkflowType="Golden Records"
                />
              ),
            },
            {
              path: 'logs/emr-logs/:batch/:job/:cluster',
              element: <EmrLogCluster processType="Company 360" processWorkflowType="Golden Records" />,
            },
          ],
        },
      ],
    },
    {
      path: '/workflow-customer-segmentation',
      element: <PrivateRoute />,
      children: [
        {
          path: '',
          element: <Sidebar />,
          children: [
            { path: '', element: <WorkflowPage processType="customer-segmentation" /> },
            {
              path: 'onboarding',
              element: <WorkflowParent headerTableData={location.state} processType="customer-segmentation" />,
            },
            {
              path: 'logs/data-processor',
              element: <ViewLogs headerTableData={location.state} processType="customer-segmentation" />,
            },
            {
              path: 'logs/data-processor/details',
              element: <LogDetails headerTableData={location.state} processType="customer-segmentation" />,
            },
            {
              path: 'logs/rule-engine',
              element: <ViewLogs headerTableData={location.state} processType="customer-segmentation" />,
            },
            {
              path: 'logs/rule-engine/details',
              element: <LogDetails headerTableData={location.state} processType="customer-segmentation" />,
            },
            {
              path: 'logs/log-analytics/detailed-logs',
              element: <LogsAnalyticsData headerTableData={location.state} processType="customer-segmentation" />,
            },
            {
              path: 'logs/detailed-logs',
              element: <DetailedLogs headerTableData={location.state} processType="customer-segmentation" />,
            },
            {
              path: 'logs/emr-logs/:batch/:job/:cluster',
              element: <EmrLogCluster processType="customer-segmentation" />,
            },
          ],
        },
      ],
    },
    {
      path: '/engagement',
      element: <PrivateRoute />,
      children: [
        {
          path: '',
          element: <Sidebar />,
          children: [
            { path: '', element: <EngagementPage /> },
            { path: 'view_details', element: <EngagementDetails headerTableData={location.state} /> },
          ],
        },
      ],
    },
    {
      path: '/approval',
      element: <PrivateRoute />,
      children: [
        {
          path: '',
          element: <Sidebar />,
          children: [{ path: '', element: <ApprovalPage /> }],
        },
      ],
    },
    {
      path: '/llm',
      element: <PrivateRoute />,
      children: [
        {
          path: '',
          element: <Sidebar />,
          children: [{ path: '', element: <LLMPage /> }],
        },
      ],
    },
    {
      path: '/user-management',
      element: <PrivateRoute />,
      children: [
        {
          path: '',
          element: <Sidebar />,
          children: [{ path: '', element: <ManagementPage /> }],
        },
      ],
    },
    {
      path: '/chat-gpt-query',
      element: <PrivateRoute />,
      children: [
        {
          path: '',
          element: <Sidebar title="chatGptQuery" />,
          children: [{ path: '', element: <ChatGPT /> }],
        },
      ],
    },
    {
      path: '/chat-gpt-file-system',
      element: <PrivateRoute />,
      children: [
        {
          path: '',
          element: <Sidebar title="chatGptfileSystem" />,
          children: [{ path: '', element: <ChatGPTFs /> }],
        },
      ],
    },
    {
      path: '/chat-gpt',
      element: <PrivateRoute />,
      children: [
        {
          path: '',
          element: <Sidebar title="chatGpt" />,
          children: [{ path: '', element: <ChatGPTQuery /> }],
        },
      ],
    },
    {
      path: '/upload-files',
      element: <PrivateRoute />,
      children: [
        {
          path: '',
          element: <Sidebar />,
          children: [{ path: '', element: <UploadFiles /> }],
        },
      ],
    },
    {
      path: '/admin-pannel',
      element: <PrivateRoute />,
      children: [
        {
          path: '',
          element: <Sidebar />,
          children: [{ path: '', element: <AdminPage /> }],
        },
      ],
    },
    {
      path: '/connectors',
      element: <PrivateRoute />,
      children: [
        {
          path: '',
          element: <Sidebar />,
          children: [{ path: '', element: <ConnectorsPage /> }],
        },
      ],
    },
    // { path: '*', element: <Navigate to="/404" replace /> },
    {
      path: '*',
      element: <PrivateRoute />,
      children: [
        {
          path: '*',
          element: <Sidebar />,
          children: [{ path: '*', element: <PageNotFound /> }],
        },
      ],
    },
    {
      path: '/about',
      element: <PrivateRoute />,
      children: [
        {
          path: '',
          element: <Sidebar />,
          children: [{ path: '', element: <AboutModal /> }],
        },
      ],
    },
  ]);
}
